import { api } from "./apiClient";

export function createDeveloperDashboardApi() {
  const deleteProperty = (id) => api.delete(`/properties/${id}`);
  const restoreProperty = (id) => api.patchQuery(`/properties/${id}/restore`);

  const toggleActiveProperty = (id) =>
    api.patchQuery(`/properties/${id}/toggle-active`);

  const toggleFeaturedProperty = (id) =>
    api.patchQuery(`/properties/${id}/toggle-featured`);

  const deleteDevelopment = (id) => api.delete(`/developments/${id}`);
  const restoreDevelopment = (id) => api.patchQuery(`/developments/${id}/restore`);

  const updateAppointmentStatus = (aptId, status) =>
    api.patchQuery(`/appointments/${aptId}/status?status=${status}`);

  const editAppointment = (aptId, data) =>
    api.put(`/appointments/${aptId}`, data);

  const approveRepresentation = (propId, reqId) =>
    api.patchQuery(`/representation/properties/${propId}/approve/${reqId}`);

  const rejectRepresentation = (propId, reqId) =>
    api.patchQuery(`/representation/properties/${propId}/reject/${reqId}`);

  const archiveInquiry = (id) => api.patchQuery(`/contact/${id}/archive`);

  return {
    deleteProperty,
    restoreProperty,
    toggleActiveProperty,
    toggleFeaturedProperty,
    deleteDevelopment,
    restoreDevelopment,
    updateAppointmentStatus,
    editAppointment,
    approveRepresentation,
    rejectRepresentation,
    archiveInquiry,
  };
}
